import {
  addClimatisseur, addProjet, deleteClimatisseur, deleteProjet, getClimatisseurInfo,
  getDataProjets, getDataClimats, getDataComptes, getDataCommandes, getProjetInfo,
  updateClimatisseur, updateProjet, getPanier, addToPanier, deleteCartItem, updateCartItem,
  addCompte, updateCompte, patchCompte, deleteCompte,
  addCommande, updateCommande, deleteCommande, login, register, getDataHistories, deleteHistory, addHistory,
  addComment, deleteComment, updateComment, firebaseSync, verifyRegister
} from "./action";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cherche: "",
  panier: [],
  listC: [],
  commandes: [],
  comptes: [],
  listP: [],
  favoris: [],
  histories: [],
  loading: false,
  error: null
};

const slice = createSlice({
  name: "jamaslens",
  initialState,
  reducers: {
    ChercherButton: (state, action) => {
      state.cherche = action.payload;
    },
    Ajouter: (state, action) => {
      state.panier.push(action.payload);
    },
    modifierChecked: (state, action) => {
      const id = action.payload;
      const item = state.panier.find(p => p.id === id);
      if (item) {
        item.checked = !item.checked;
      }
    },
    supprimer: (state, action) => {
      state.panier = state.panier.filter(p => !p.checked);
    },
    modifierQuantite: (state, action) => {
      const { item, type } = action.payload;
      const product = state.panier.find(p => p.idPro === item.idPro);
      if (product) {
        if (type === "plus") {
          product.quantite += 1;
        } else if (type === "moins" && product.quantite > 1) {
          product.quantite -= 1;
        }
      }
    },
    AjouterCommentaire: (state, action) => {
      const { climatiseurId, commentaire } = action.payload;
      const climatiseur = state.listC.find(c => c.id == climatiseurId);
      if (climatiseur) {
        if (!climatiseur.commantaires) climatiseur.commantaires = [];
        climatiseur.commantaires.push(commentaire);
      }
    },
    LikeCommentaire: (state, action) => {
      const { climatiseurId, commentaireId, userEmail } = action.payload;
      const climatiseur = state.listC.find(c => c.id == climatiseurId);
      if (climatiseur) {
        const comment = climatiseur.commantaires.find(com => com.id === commentaireId);
        if (comment) {
          if (!comment.likedBy) comment.likedBy = [];
          if (!comment.dislikedBy) comment.dislikedBy = [];

          if (comment.likedBy.includes(userEmail)) {
            // Already liked -> remove like
            comment.likedBy = comment.likedBy.filter(email => email !== userEmail);
            comment.like = Math.max(0, (comment.like || 1) - 1);
          } else {
            // Not liked -> add like
            comment.likedBy.push(userEmail);
            comment.like = (comment.like || 0) + 1;
            // If disliked, remove dislike
            if (comment.dislikedBy.includes(userEmail)) {
              comment.dislikedBy = comment.dislikedBy.filter(email => email !== userEmail);
              comment.dislike = Math.max(0, (comment.dislike || 1) - 1);
            }
          }
        }
      }
    },
    DislikeCommentaire: (state, action) => {
      const { climatiseurId, commentaireId, userEmail } = action.payload;
      const climatiseur = state.listC.find(c => c.id == climatiseurId);
      if (climatiseur) {
        const comment = climatiseur.commantaires.find(com => com.id === commentaireId);
        if (comment) {
          if (!comment.likedBy) comment.likedBy = [];
          if (!comment.dislikedBy) comment.dislikedBy = [];

          if (comment.dislikedBy.includes(userEmail)) {
            // Already disliked -> remove dislike
            comment.dislikedBy = comment.dislikedBy.filter(email => email !== userEmail);
            comment.dislike = Math.max(0, (comment.dislike || 1) - 1);
          } else {
            // Not disliked -> add dislike
            comment.dislikedBy.push(userEmail);
            comment.dislike = (comment.dislike || 0) + 1;
            // If liked, remove like
            if (comment.likedBy.includes(userEmail)) {
              comment.likedBy = comment.likedBy.filter(email => email !== userEmail);
              comment.like = Math.max(0, (comment.like || 1) - 1);
            }
          }
        }
      }
    },
    SupprimerCommentaire: (state, action) => {
      const { climatiseurId, commentaireId } = action.payload;
      const product = state.listC.find(p => p.id == climatiseurId);
      if (product && product.commantaires) {
        product.commantaires = product.commantaires.filter(com => com.id != commentaireId);
      }
    },
    SupprimerClimatiseur: (state, action) => {
      state.listC = state.listC.filter(c => c.id !== action.payload);
    },
    EnregistrerClimatiseur: (state, action) => {
      const data = action.payload;
      const index = data.id ? state.listC.findIndex(c => c.id.toString() === data.id.toString()) : -1;

      if (index !== -1) {
        state.listC[index] = { ...state.listC[index], ...data };
      } else {
        const newId = state.listC.length > 0 ? Math.max(...state.listC.map(c => parseInt(c.id) || 0)) + 1 : 1;
        state.listC.push({ ...data, id: newId.toString(), commantaires: [] });
      }
    },
    SupprimerProjet: (state, action) => {
      state.listP = state.listP.filter(p => p.id !== action.payload);
    },
    EnregistrerProjet: (state, action) => {
      const data = action.payload;
      const index = data.id ? state.listP.findIndex(p => p.id.toString() === data.id.toString()) : -1;

      if (index !== -1) {
        state.listP[index] = { ...state.listP[index], ...data };
      } else {
        const newId = state.listP.length > 0 ? Math.max(...state.listP.map(p => parseInt(p.id) || 0)) + 1 : 1;
        state.listP.push({ ...data, id: newId.toString() });
      }
    },
    SupprimerCompte: (state, action) => {
      state.comptes = state.comptes.filter(c => c.id != action.payload);
    },
    AjouterCompte: (state, action) => {
      state.comptes.push({
        ...action.payload,
        id: state.comptes.length > 0 ? Math.max(...state.comptes.map(c => c.id)) + 1 : 1,
        date: new Date().toLocaleDateString('fr-FR'), // DD/MM/YYYY
        status: 'Actif'
      });
    },
    ModifierStatutCompte: (state, action) => {
      const { id, status } = action.payload;
      const compte = state.comptes.find(c => c.id == id);
      if (compte) {
        compte.status = status;
      }
    },
    ModifierStatutCommentaire: (state, action) => {
      const { climatiseurId, commentaireId, status } = action.payload;
      const product = state.listC.find(p => p.id == climatiseurId);
      if (product && product.commantaires) {
        const comment = product.commantaires.find(com => com.id === commentaireId);
        if (comment) {
          comment.status = status;
        }
      }
    },
    AjouterCommentaireAdmin: (state, action) => {
      const { climatiseurId, newComment } = action.payload;
      const product = state.listC.find(p => p.id == climatiseurId);
      if (product) {
        if (!product.commantaires) product.commantaires = [];
        const allComments = state.listC.flatMap(c => c.commantaires || []);
        const maxId = allComments.length > 0 ? Math.max(...allComments.map(c => c.id)) : 0;
        product.commantaires.push({
          ...newComment,
          id: maxId + 1,
          like: 0,
          dislike: 0,
          status: 'validé'
        });
      }
    },
    toggleFavoris: (state, action) => {
      const climId = action.payload;
      const index = state.favoris.findIndex(id => String(id) === String(climId));
      if (index !== -1) {
        state.favoris.splice(index, 1);
      } else {
        state.favoris.push(climId);
      }
    }
  },
  extraReducers: (builder) => {
    builder
      // getDataClimats
      .addCase(getDataClimats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDataClimats.fulfilled, (state, action) => {
        state.loading = false;
        state.listC = action.payload;
      })
      .addCase(getDataClimats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // getDataProjets
      .addCase(getDataProjets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDataProjets.fulfilled, (state, action) => {
        state.loading = false;
        state.listP = action.payload;
      })
      .addCase(getDataProjets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // getDataComptes
      .addCase(getDataComptes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDataComptes.fulfilled, (state, action) => {
        state.loading = false;
        state.comptes = action.payload;
        // Sync logged user favoris and history on load
        try {
            const loggedUserStr = localStorage.getItem('user');
            if (loggedUserStr) {
                const loggedUser = JSON.parse(loggedUserStr);
                const userInDb = action.payload.find(c => c.email?.toLowerCase() === loggedUser.email?.toLowerCase());
                if (userInDb) {
                    state.favoris = userInDb.favoris || [];
                    state.panier = userInDb.panier || [];
                    const userPayload = JSON.stringify({
                        id: userInDb.id,
                        name: userInDb.username || userInDb.name || loggedUser.name,
                        email: loggedUser.email,
                        role: loggedUser.role,
                        isGoogle: loggedUser.isGoogle,
                        profilePic: userInDb.image_user?.length < 100000 
                            ? userInDb.image_user 
                            : (loggedUser.profilePic?.length < 100000 ? loggedUser.profilePic : null)
                    });

                    try {
                        localStorage.setItem('user', userPayload);
                    } catch (e) {
                        localStorage.clear();
                        localStorage.setItem('user', JSON.stringify({
                            id: userInDb.id,
                            name: userInDb.username || userInDb.name || loggedUser.name,
                            email: loggedUser.email,
                            role: loggedUser.role,
                            isGoogle: loggedUser.isGoogle,
                            profilePic: null
                        }));
                    }
                } else {
                    // Stale user session not found in database (e.g. database reset or cleared)
                    localStorage.removeItem('user');
                    localStorage.removeItem('firebase_token');
                    window.location.href = '/login';
                }
            }
        } catch(e) { console.error(e) }
      })
      .addCase(getDataComptes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // getDataCommandes
      .addCase(getDataCommandes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDataCommandes.fulfilled, (state, action) => {
        state.loading = false;
        state.commandes = action.payload;
      })
      .addCase(getDataCommandes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // getPanier
      .addCase(getPanier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPanier.fulfilled, (state, action) => {
        state.loading = false;
        state.panier = action.payload;
      })
      .addCase(getPanier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // addToPanier
      .addCase(addToPanier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addToPanier.fulfilled, (state, action) => {
        state.loading = false;
        state.panier.push(action.payload);
      })
      .addCase(addToPanier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // deleteCartItem
      .addCase(deleteCartItem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCartItem.fulfilled, (state, action) => {
        state.loading = false;
        state.panier = state.panier.filter(p => p.id !== action.meta.arg);
      })
      .addCase(deleteCartItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // updateCartItem
      .addCase(updateCartItem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCartItem.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.panier.findIndex(p => p.id == action.payload.id);
        if (index != -1) {
          state.panier[index] = action.payload;
        }
      })
      .addCase(updateCartItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //addClimatisseur
      .addCase(addClimatisseur.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addClimatisseur.fulfilled, (state, action) => {
        state.loading = false;
        state.listC.push(action.payload);
      })
      .addCase(addClimatisseur.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //updateClimatisseur
      .addCase(updateClimatisseur.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClimatisseur.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.listC.findIndex(c => c.id == action.payload.id);
        if (index != -1) {
          state.listC[index] = action.payload;
        }
      })
      .addCase(updateClimatisseur.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //deleteClimatisseur
      .addCase(deleteClimatisseur.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClimatisseur.fulfilled, (state, action) => {
        state.loading = false;
        state.listC = state.listC.filter(c => c.id.toString() !== action.meta.arg.toString());
      })
      .addCase(deleteClimatisseur.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //getClimatisseurInfo
      .addCase(getClimatisseurInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClimatisseurInfo.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.listC.findIndex(c => c.id == action.payload.id);
        if (index != -1) {
          state.listC[index] = action.payload;
        }
      })
      .addCase(getClimatisseurInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //addProjet
      .addCase(addProjet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addProjet.fulfilled, (state, action) => {
        state.loading = false;
        state.listP.push(action.payload);
      })
      .addCase(addProjet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //updateProjet
      .addCase(updateProjet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProjet.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.listP.findIndex(p => p.id == action.payload.id);
        if (index != -1) {
          state.listP[index] = action.payload;
        }
      })
      .addCase(updateProjet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //deleteProjet
      .addCase(deleteProjet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProjet.fulfilled, (state, action) => {
        state.loading = false;
        state.listP = state.listP.filter(p => p.id.toString() !== action.meta.arg.toString());
      })
      .addCase(deleteProjet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      //getProjetInfo
      .addCase(getProjetInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProjetInfo.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.listP.findIndex(p => p.id == action.payload.id);
        if (index != -1) {
          state.listP[index] = action.payload;
        }
      })
      .addCase(getProjetInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // addCompte
      .addCase(addCompte.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCompte.fulfilled, (state, action) => {
        state.loading = false;
        state.comptes.push(action.payload);
      })
      .addCase(addCompte.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // updateCompte
      .addCase(updateCompte.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCompte.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.comptes.findIndex(c => c.id == action.payload.id);
        if (index != -1) {
          state.comptes[index] = action.payload;
        }
      })
      .addCase(updateCompte.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // deleteCompte
      .addCase(deleteCompte.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCompte.fulfilled, (state, action) => {
        state.loading = false;
        state.comptes = state.comptes.filter(c => c.id.toString() !== action.meta.arg.toString());
      })
      .addCase(deleteCompte.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // addCommande
      .addCase(addCommande.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCommande.fulfilled, (state, action) => {
        state.loading = false;
        state.commandes.push(action.payload);
      })
      .addCase(addCommande.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // updateCommande
      .addCase(updateCommande.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCommande.fulfilled, (state, action) => {
        state.loading = false;
        // Mise à jour de la commande dans la liste en utilisant une comparaison d'ID robuste
        const updatedCmd = action.payload;
        const index = state.commandes.findIndex(c => String(c.id) === String(updatedCmd.id));
        if (index !== -1) {
          state.commandes[index] = updatedCmd;
        }
      })
      .addCase(updateCommande.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // DELETE COMMANDE
      .addCase(deleteCommande.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCommande.fulfilled, (state, action) => {
        state.loading = false;
        // Suppression de la commande par son ID (passé en argument du thunk : action.meta.arg)
        const idToDelete = String(action.meta.arg);
        state.commandes = state.commandes.filter(c => String(c.id) !== idToDelete);
      })
      .addCase(deleteCommande.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // patchCompte
      .addCase(patchCompte.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(patchCompte.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.comptes.findIndex(c => c.id == action.payload.id);
        if (index != -1) {
          state.comptes[index] = action.payload;
        }
        // Update local state if the patched user is the logged in user
        try {
            const loggedUserStr = localStorage.getItem('user');
            if (loggedUserStr) {
                const loggedUser = JSON.parse(loggedUserStr);
                if (loggedUser.email === action.payload.email) {
                    if (action.payload.favoris) state.favoris = action.payload.favoris;
                    if (action.payload.panier) state.panier = action.payload.panier;
                    
                    const newPayload = JSON.stringify({
                        id: loggedUser.id,
                        name: action.payload.username || loggedUser.name,
                        email: action.payload.email || loggedUser.email,
                        role: action.payload.role ? action.payload.role.toLowerCase() : loggedUser.role,
                        isGoogle: loggedUser.isGoogle,
                        profilePic: action.payload.image_user?.length < 100000 
                            ? action.payload.image_user 
                            : (loggedUser.profilePic?.length < 100000 ? loggedUser.profilePic : null)
                    });
                    
                    try {
                        localStorage.setItem('user', newPayload);
                    } catch(e) {
                        localStorage.clear();
                        localStorage.setItem('user', JSON.stringify({
                            id: loggedUser.id,
                            name: action.payload.username || loggedUser.name,
                            email: action.payload.email || loggedUser.email,
                            role: action.payload.role ? action.payload.role.toLowerCase() : loggedUser.role,
                            isGoogle: loggedUser.isGoogle,
                            profilePic: null
                        }));
                    }
                }
            }
        } catch(e) { console.error("LocalStorage Update Error:", e); }
      })
      .addCase(patchCompte.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // login
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.favoris = action.payload.favoris || [];
        state.panier = action.payload.panier || [];
      })
      // register
      .addCase(register.fulfilled, (state, action) => {
        state.loading = false;
        state.favoris = action.payload.favoris || [];
        state.panier = action.payload.panier || [];
      })
      // firebaseSync
      .addCase(firebaseSync.fulfilled, (state, action) => {
        state.loading = false;
        const user = action.payload.user;
        if (user && !state.comptes.some(c => c.id === user.id)) {
            state.comptes.push(user);
        }
      })
      // verifyRegister
      .addCase(verifyRegister.fulfilled, (state, action) => {
        state.loading = false;
        const user = action.payload.user;
        if (user && !state.comptes.some(c => c.id === user.id)) {
            state.comptes.push(user);
        }
      })
      // getDataHistories
      .addCase(getDataHistories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDataHistories.fulfilled, (state, action) => {
        state.loading = false;
        state.histories = action.payload;
      })
      .addCase(getDataHistories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        console.error("getDataHistories rejected error:", action.error);
      })
      // deleteHistory
      .addCase(deleteHistory.fulfilled, (state, action) => {
        if (action.meta.arg === 'all') {
            state.histories = [];
        } else {
            state.histories = state.histories.filter(h => h.id !== action.meta.arg);
        }
      })
      // addHistory
      .addCase(addHistory.fulfilled, (state, action) => {
        state.histories.unshift(action.payload);
      })
      // addComment
      .addCase(addComment.fulfilled, (state, action) => {
        const product = state.listC.find(p => p.id == action.payload.climatiseur_id);
        if (product) {
          if (!product.commantaires) product.commantaires = [];
          product.commantaires.push(action.payload);
        }
      })
      // updateComment
      .addCase(updateComment.fulfilled, (state, action) => {
        state.listC.forEach(product => {
          if (product.commantaires) {
            const index = product.commantaires.findIndex(com => com.id == action.payload.id);
            if (index !== -1) {
              product.commantaires[index] = { ...product.commantaires[index], ...action.payload };
            }
          }
        });
      })
      // deleteComment
      .addCase(deleteComment.fulfilled, (state, action) => {
        state.listC.forEach(product => {
          if (product.commantaires) {
            product.commantaires = product.commantaires.filter(com => com.id != action.meta.arg);
          }
        });
      })
  }
});

export const {
  ChercherButton, Ajouter, modifierChecked, supprimer, modifierQuantite,
  AjouterCommentaire, LikeCommentaire, DislikeCommentaire, SupprimerCommentaire,
  SupprimerClimatiseur, EnregistrerClimatiseur, SupprimerProjet, EnregistrerProjet,
  SupprimerCompte, ModifierStatutCompte, AjouterCompte,
  ModifierStatutCommentaire, AjouterCommentaireAdmin,
  toggleFavoris
} = slice.actions;
export default slice;